export default __webpack_public_path__ + "1128711aea4673cac78f3cabe0fbeb07.png";